import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel base code
    const f = window;
    const b = document;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = b.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = b.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    window.fbq('init', '1209282797134007');
    window.fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}